import {ChakraDiv, ChakraButton} from '@linx-security/ui/utils/chakra-elements';
import React from 'react';

import {CloseButton, Label, Text} from '../../index';
import {useToastStyleConfig} from '../../theme-config';

import {ToastIcon} from './ToastIcon';
import {ToastContextProvider, ToastStylesProvider} from './context';
import type {ToastProps} from './types';

export const Toast = (props: ToastProps) => {
  const {status = `info`, retry, id, title, isClosable, onClose, description, icon} = props;
  const styles = useToastStyleConfig(props);

  const ids = id
    ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`,
      }
    : undefined;

  return (
    <ToastContextProvider value={{status}}>
      <ToastStylesProvider value={styles}>
        <ChakraDiv id={ids?.root} __css={styles.root}>
          <ToastIcon>{icon}</ToastIcon>
          <ChakraDiv __css={styles.message}>
            {title && (
              <Label size={`md`} id={ids?.title} __css={styles.title} isTruncated>
                {title}
              </Label>
            )}
            {description && (
              <Text size={`md`} id={ids?.description} __css={styles.description}>
                {description}
              </Text>
            )}
          </ChakraDiv>
          <ChakraDiv __css={styles.actions}>
            {typeof retry === `function` ? (
              <ChakraButton __css={styles.retry} {...retry(status)} />
            ) : (
              typeof retry === `object` && <ChakraButton __css={styles.retry} {...retry} />
            )}
            {isClosable && <CloseButton __css={styles.close} onClick={onClose} />}
          </ChakraDiv>
        </ChakraDiv>
      </ToastStylesProvider>
    </ToastContextProvider>
  );
};
